module.exports = __webpack_public_path__ + "static/media/admin-dashboard.bc4cdd4f.png";